import { useCallback } from 'react';
import { format, parseISO } from 'date-fns';

import { useDateFns } from '../../Provider';

type DateOrISOString = Date | string;

/**
 * https://date-fns.org/v2.28.0/docs/format
 */
const useFormatDate = (dateFormat: string) => {
  const fnsLocale = useDateFns();
  return useCallback(
    (date: DateOrISOString): string => {
      let parsed = date as Date;
      if (typeof date === 'string') {
        parsed = parseISO(date);
      }
      return format(parsed, dateFormat, { locale: fnsLocale });
    },
    [fnsLocale, dateFormat]
  );
};

export default useFormatDate;
